module.exports = __webpack_public_path__ + "static/img/A24.d24c0b49.jpg";